import React from 'react';
import { Authorization } from 'glxl-helpers';
import apiCall from "../apiCall";
import tabInfo from '../../helpers/tabInfo';
import ContentContainer from "../elements/ContentContainer";
import { __, setLocale } from 'i18n-for-browser';
import { icons } from '../../assets/assets.js';
import Visible from '../../assets/img/icons/visible.png';
import Invisible from '../../assets/img/icons/invisible.png';
import TopBar from '../elements/TopBar';
import Auth from '../auth';

const auth = new Authorization();

class Password extends React.Component {
  static defaultProps = {
    desktop: false,
  };

  constructor(props) {
    super(props);
    this.state = {
        secondPasswordCorrect: false,
        passwordCorrect: false,
        wrongSecondPassword: false,
        wrongPassword: false,
        password: '',
        secondPassword: '',
        generalMaterial: null,
        passwordVisibility: false,
        secondPasswordVisibility: false,
        showTopbar: false,
    }
  }

  componentWillMount() {
    this.fetchGeneralMaterial();
  }

  fetchGeneralMaterial() {
    const { generalMaterialId } = this.props.match.params;
    apiCall(`/generalMaterial/${generalMaterialId}`, null, 'GET')
      .then((generalMaterial) => {
        if (generalMaterial.windowTitle) {
            tabInfo.setWindowTitle(generalMaterial.windowTitle);
        }
        if (generalMaterial.faviconUrl) {
            tabInfo.setFavicon(generalMaterial.faviconUrl);
        }
        setLocale(generalMaterial.Language.code);
        this.setState({ generalMaterial });

        const token = sessionStorage.getItem('token') || auth.getAuthToken();
        if (token) {
            apiCall('/user/me', null, 'GET', {}, false)
                .then((user) => {
                    if (user && user.id) {
                        this.setState({ showTopbar: true });
                    } else {
                        if (!generalMaterial.isPublic) {
                            window.location.href = '/login';
                        }
                    }
                })
                .catch((err) => {
                    console.error(err.message);
                });
            } else {
                if (!generalMaterial.isPublic) {
                    window.location.href = '/login';
                }
            }
      });
  }

  handleChange = (ev) => {
    this.setState({ [ev.target.name]: ev.target.value });
  }

  handleCompleted = () => {
    window.open(this.state.generalMaterial.alternateUrl, "_blank");
  };

  handleSubmit = (ev, fieldName) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (fieldName === 'password') {
        const correct = this.state.generalMaterial.password === this.state.password;
        this.setState({ passwordCorrect: correct, wrongPassword: !correct });
        if (correct && !this.state.generalMaterial.secondPassword) {
            this.handleCompleted();
        }
    } else if (fieldName === 'secondPassword') {
        const correct = this.state.generalMaterial.secondPassword === this.state.secondPassword;
        this.setState({ secondPasswordCorrect: correct, wrongSecondPassword: !correct });
        if (correct) {
            this.handleCompleted();
        }
    }
    return false;
  }

  render() {
    const { generalMaterial } = this.state;
    let backgroundUrl = null;
    if (generalMaterial && generalMaterial.Background && generalMaterial.Background.url) {
        backgroundUrl = generalMaterial.Background.url;
    }
    const AuthTopHeader = Auth(TopBar, ['groupleader', 'groupmember', 'classleader'], null, { "desktop": !!this.props.desktop });
    return (
        <React.Fragment>
            {/* {this.state.showTopbar ? <AuthTopHeader key={'auth-top-bar'} /> : null} */}
            <div style={backgroundUrl ? { backgroundImage: `url(${backgroundUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}} className={this.props.desktop ? `portal-vimeo portal-home darkBckg${backgroundUrl ? ' custom-background' : ''}` : `portal-vimeo portal-home darkBckg${backgroundUrl ? ' custom-background' : ''}`}>
                {generalMaterial && generalMaterial.id ? (
                    <div style={{
                        margin: '0 auto',
                        paddingLeft: '15px',
                        paddingRight: '15px',
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                    }}>
                        <form onSubmit={(ev) => this.handleSubmit(ev, "password")} action="#" method="GET" style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <ContentContainer style={{
                                margin: '0 auto',
                                width: '100%',
                                maxWidth: '450px',
                            }}>
                                <h3 style={{textAlign: 'center', marginBottom: "20px", fontWeight: 'bold'}}>{__("sim_wachtwoord").toUpperCase() + (this.state.generalMaterial.secondPassword ? ' 1:' : ':')}</h3>
                                <div className="input-container" style={{ position: 'relative' }}>
                                    <input disabled={this.state.passwordCorrect} type={this.state.passwordVisibility ? 'text' : 'password'} placeholder={__("sim_wachtwoord")} name="password" onChange={this.handleChange} value={this.state.password} />
                                    <span
                                        className="password-visibility-container"
                                        style={{
                                        background: 'transparent',
                                        height: '40px',
                                        position: 'absolute',
                                        right: 0,
                                        top: 0,
                                        borderRadius: '16px',
                                        display: 'flex',
                                        padding: 8
                                        }}
                                    >
                                        <img
                                        src={this.state.passwordVisibility ? Visible : Invisible}
                                        alt="toggle visibility"
                                        onClick={() => { this.setState({ passwordVisibility: !this.state.passwordVisibility }); }}
                                        style={{
                                            width: '20px',
                                            justifySelf: 'center',
                                            alignSelf: 'center',
                                            cursor: 'pointer',
                                        }}
                                        />
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
                                        <button style={{ margin: 0 }} type="submit"><span>{__('sim_versturen')}</span></button>
                                        {this.state.passwordCorrect ? <img style={{ width: '20px', position: 'absolute', left: 'calc((100% / 2) + 85px)' }} src={icons.check} alt="check" /> : null}
                                    </div>
                                { this.state.wrongPassword ? (
                                    <div className="login-failed" style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>
                                    {__('sim_password_wrong_password')}
                                    </div>
                                ) : null }
                            </ContentContainer>
                        </form>
                        {this.state.generalMaterial.secondPassword ? (
                            <form onSubmit={(ev) => this.handleSubmit(ev, "secondPassword")} action="#" method="GET" style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: '20px',
                                opacity: this.state.passwordCorrect ? 1 : 0,
                                pointerEvents: this.state.passwordCorrect ? 'initial' : 'none',
                            }}>
                                <ContentContainer style={{
                                    margin: '0 auto',
                                    width: '100%',
                                    maxWidth: '450px',
                                }}>
                                    <h3 style={{textAlign: 'center', marginBottom: "20px", fontWeight: 'bold'}}>{__("sim_wachtwoord").toUpperCase() + ' 2:'}</h3>
                                    <div className="input-container" style={{ position: 'relative' }}>
                                        <input disabled={this.state.secondPasswordCorrect} type={this.state.secondPasswordVisibility ? 'text' : 'password'} placeholder={__("sim_wachtwoord")} name="secondPassword" onChange={this.handleChange} value={this.state.secondPassword} />
                                        <span
                                            className="password-visibility-container"
                                            style={{
                                            background: 'transparent',
                                            height: '40px',
                                            position: 'absolute',
                                            right: 0,
                                            top: 0,
                                            borderRadius: '16px',
                                            display: 'flex',
                                            padding: 8
                                            }}
                                        >
                                            <img
                                            src={this.state.secondPasswordVisibility ? Visible : Invisible}
                                            alt="toggle visibility"
                                            onClick={() => { this.setState({ secondPasswordVisibility: !this.state.secondPasswordVisibility }); }}
                                            style={{
                                                width: '20px',
                                                justifySelf: 'center',
                                                alignSelf: 'center',
                                                cursor: 'pointer',
                                            }}
                                            />
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
                                        <button style={{ margin: 0 }} type="submit"><span>{__('sim_versturen')}</span></button>
                                        {this.state.secondPasswordCorrect ? <img style={{ width: '20px', position: 'absolute', left: 'calc((100% / 2) + 85px)' }} src={icons.check} alt="check" /> : null}
                                    </div>
                                    { this.state.wrongSecondPassword ? (
                                        <div className="login-failed" style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>
                                        {__('sim_password_wrong_password')}
                                        </div>
                                    ) : null }
                                </ContentContainer>
                            </form>
                        ) : null}
                    </div>
                ) : null}
            </div>
      </React.Fragment>
    );
  }
}

export default Password;



// WEBPACK FOOTER //
// ./src/components/routes/Password.js